module.exports = __webpack_public_path__ + "static/media/efficiency.a24aa116.svg";